import CodeServiceModel   from '@/models/CodeServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

@model.urnResource('code_entertainment')
@doc.path('/code_entertainments/{?id}')
export default class CodeEntertainmentModel extends CodeServiceModel {

	@doc.string declare entertainmentUrn: Urn;
}